commonModule.factory("TLCError",['errorMessageLookupService', 'AppSettings', function(errorMessageLookupService, AppSettings) {
    var TLCError = function(orig, appErrorCode){

        this.originalError = orig;
        this.appErrorCode = appErrorCode;
        this.showConsoleErr = AppSettings.showErrorsOnConsole || false;
        this.appErrorMsg = null;
    }

    TLCError.prototype = Object.create(Error.prototype);
    TLCError.prototype.constructor = TLCError;

    return TLCError;
}]);